
// import React, { useState, useEffect, useCallback } from 'react';
// import styles from './HeaderInvoiceTable.module.css';
// import * as XLSX from 'xlsx';
// import { invoiceHeaderApi } from '../../../../../api/invoiceHeader/invoiceHeaderApi';
// import InvoiceModal from './InvoiceModal';

// const HeaderInvoiceTable = () => {
//   const [invoices, setInvoices] = useState([]);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const [totalItems, setTotalItems] = useState(0);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedMonth, setSelectedMonth] = useState('');
//   const [selectedStatus, setSelectedStatus] = useState('');
//   const [sortBy, setSortBy] = useState('');
//   const [sortOrder, setSortOrder] = useState('desc');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedInvoice, setSelectedInvoice] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const itemsPerPage = 20;
//   const [pdfAvailability, setPdfAvailability] = useState({});
//   const [downloadingPdf, setDownloadingPdf] = useState({});

//   const months = [
//     { label: 'All Months', value: '' },
//     { label: 'January', value: '1' },
//     { label: 'February', value: '2' },
//     { label: 'March', value: '3' },
//     { label: 'April', value: '4' },
//     { label: 'May', value: '5' },
//     { label: 'June', value: '6' },
//     { label: 'July', value: '7' },
//     { label: 'August', value: '8' },
//     { label: 'September', value: '9' },
//     { label: 'October', value: '10' },
//     { label: 'November', value: '11' },
//     { label: 'December', value: '12' }
//   ];

//   const statusFilters = [
//     { label: 'All', value: '' },
//     { label: 'Open', value: 'Open' },
//     { label: 'Closed', value: 'Closed' },
//     { label: 'Partially Open', value: 'Partially Open' },
//     { label: 'Canceled', value: 'Canceled' }
//   ];

//   const fetchInvoices = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError(null);
      
//       console.log('🔍 Fetching invoice headers...');
      
//       const data = await invoiceHeaderApi.getInvoiceHeaders(
//         currentPage, 
//         itemsPerPage, 
//         searchTerm, 
//         selectedMonth, 
//         selectedStatus,
//         sortBy,
//         sortOrder
//       );
      
//       console.log('✅ Invoice headers received:', data);
      
//       if (data && data.invoiceHeaders && Array.isArray(data.invoiceHeaders)) {
//         setInvoices(data.invoiceHeaders);
//         setTotalPages(data.totalPages || 0);
//         setTotalItems(data.totalItems || 0);
//       } else {
//         console.error('❌ Invalid data structure:', data);
//         setInvoices([]);
//         setError('Invalid data received from server');
//       }
//     } catch (err) {
//       setError('Failed to load invoice headers');
//       console.error('❌ Error fetching invoice headers:', err);
//       setInvoices([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [currentPage, searchTerm, selectedMonth, selectedStatus, sortBy, sortOrder]);

//   // Check PDF availability whenever invoices change
//   useEffect(() => {
//     const checkPdfAvailability = async () => {
//       if (invoices.length === 0) {
//         setPdfAvailability({});
//         return;
//       }

//       console.log('🔍 Checking PDF availability for', invoices.length, 'invoices');
      
//       const availabilityMap = {};
      
//       // Check all invoices in parallel
//       const checkPromises = invoices.map(async (invoice) => {
//         try {
//           const result = await invoiceHeaderApi.checkPdfExists(invoice.invoiceNum);
//           const exists = result?.exists === true;
//           return [invoice.invoiceNum, exists];
//         } catch (error) {
//           console.error(`Error checking PDF for ${invoice.invoiceNum}:`, error);
//           return [invoice.invoiceNum, false];
//         }
//       });

//       const results = await Promise.all(checkPromises);
      
//       results.forEach(([invoiceNum, exists]) => {
//         availabilityMap[invoiceNum] = exists;
//       });
      
//       console.log('✅ PDF check complete. Found', Object.values(availabilityMap).filter(v => v).length, 'PDFs');
      
//       setPdfAvailability(availabilityMap);
//     };

//     checkPdfAvailability();
//   }, [invoices]);

//   // Handle PDF download
//   const handleDownloadPdf = async (docNum, e) => {
//     e.stopPropagation();
    
//     console.log('📥 Downloading PDF for invoice:', docNum);
    
//     try {
//       setDownloadingPdf(prev => ({ ...prev, [docNum]: true }));
//       await invoiceHeaderApi.downloadInvoicePdf(docNum);
//       console.log('✅ PDF download initiated successfully');
//     } catch (error) {
//       console.error('❌ Error downloading PDF:', error);
//       alert('Failed to download PDF. Please try again.');
//     } finally {
//       setDownloadingPdf(prev => ({ ...prev, [docNum]: false }));
//     }
//   };

//   useEffect(() => {
//     fetchInvoices();
//   }, [fetchInvoices]);

//   const handleSearch = () => {
//     setCurrentPage(0);
//   };

//   const handleClearFilters = () => {
//     setSearchTerm('');
//     setSelectedMonth('');
//     setSelectedStatus('');
//     setSortBy('');
//     setSortOrder('desc');
//     setCurrentPage(0);
//   };

//   const handleClearSearch = () => {
//     setSearchTerm('');
//     setCurrentPage(0);
//   };

//   const handleMonthChange = (value) => {
//     setSelectedMonth(value);
//     setCurrentPage(0);
//   };

//   const handleStatusChange = (value) => {
//     setSelectedStatus(value);
//     setCurrentPage(0);
//   };

//   const handleSort = (column) => {
//     if (sortBy === column) {
//       setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
//     } else {
//       setSortBy(column);
//       setSortOrder('asc');
//     }
//     setCurrentPage(0);
//   };

//   const handleInvoiceClick = async (invoiceNum) => {
//     try {
//       setLoading(true);
//       const invoiceDetails = await invoiceHeaderApi.getInvoiceDetails(invoiceNum);
//       setSelectedInvoice(invoiceDetails);
//       setIsModalOpen(true);
//     } catch (err) {
//       console.error('Error fetching invoice details:', err);
//       alert('Failed to load invoice details');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedInvoice(null);
//   };

//   // const handleExportExcel = async () => {
//   //   try {
//   //     setLoading(true);
//   //     console.log('📊 Exporting invoice headers to Excel...');
      
//   //     const data = await invoiceHeaderApi.exportInvoiceHeaders(searchTerm, selectedMonth, selectedStatus);
      
//   //     if (!data || !Array.isArray(data) || data.length === 0) {
//   //       alert('No data to export');
//   //       return;
//   //     }

//   //     const worksheet = XLSX.utils.json_to_sheet(data.map(invoice => ({
//   //       'Invoice#': invoice.invoiceNum,
//   //       'Invoice Date': invoice.invoiceDate,
//   //       'Status': invoice.status,
//   //       'SO': invoice.soNum,
//   //       'SO Date': invoice.soDate,
//   //       'Order Time': invoice.orderTime,
//   //       'Invoice Time': invoice.invoiceTime,
//   //       'Contact Person Name': invoice.contactPersonName,
//   //       'Contact Person Code': invoice.contactPersonCode,
//   //       'Due Date': invoice.dueDate,
//   //       'Customer Code': invoice.customerCode,
//   //       'Customer Name': invoice.customerName,
//   //       'Total Lines': invoice.totalLines,
//   //       'Total Amount': invoice.totalAmount,
//   //       'Currency': invoice.currency,
//   //       'Dispatch Date': invoice.dispatchDate,
//   //       'Tracking #': invoice.trackingNum,
//   //       'Transport': invoice.transport,
//   //       'Sales Person Code': invoice.salesPersonCode,
//   //       'Sales Person': invoice.salesPerson
//   //     })));
      
//   //     const workbook = XLSX.utils.book_new();
//   //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoice Headers');
//   //     XLSX.writeFile(workbook, `invoice_headers_${new Date().toISOString().split('T')[0]}.xlsx`);
      
//   //     console.log('✅ Exported', data.length, 'records to Excel');
//   //   } catch (err) {
//   //     console.error('❌ Error exporting invoice headers:', err);
//   //     alert('Failed to export data');
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const handleExportExcel = async () => {
//     try {
//       setLoading(true);
//       console.log('📊 Exporting invoice headers to Excel...');
      
//       const data = await invoiceHeaderApi.exportInvoiceHeaders(searchTerm, selectedMonth, selectedStatus);
      
//       if (!data || !Array.isArray(data) || data.length === 0) {
//         alert('No data to export');
//         return;
//       }

//       const worksheet = XLSX.utils.json_to_sheet(data.map(invoice => ({
//         'Invoice#': invoice.invoiceNum,
//         'Invoice Date': invoice.invoiceDate,
//         'Status': invoice.status,
//         'SO': invoice.soNum,
//         'SO Date': invoice.soDate,
//         'Order Time': invoice.orderTime,
//         'Invoice Time': invoice.invoiceTime,
//         'Contact Person Name': invoice.contactPersonName,
//         'Due Date': invoice.dueDate,
//         'Customer Name': invoice.customerName,
//         'Total Lines': invoice.totalLines,
//         'Total Amount': invoice.totalAmount,
//         'Currency': invoice.currency,
//         'Dispatch Date': invoice.dispatchDate,
//         'Tracking #': invoice.trackingNum,
//         'Transport': invoice.transport,
//         'Sales Person': invoice.salesPerson
//       })));
      
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoice Headers');
//       XLSX.writeFile(workbook, `invoice_headers_${new Date().toISOString().split('T')[0]}.xlsx`);
      
//       console.log('✅ Exported', data.length, 'records to Excel');
//     } catch (err) {
//       console.error('❌ Error exporting invoice headers:', err);
//       alert('Failed to export data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatCurrency = (amount, currency = 'INR') => {
//     const symbol = currency === 'USD' ? '$' : '₹';
//     return symbol + (amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-GB', { 
//       day: '2-digit', 
//       month: 'short', 
//       year: 'numeric' 
//     });
//   };

//   const formatTime = (timeString) => {
//     if (!timeString) return 'N/A';
//     const date = new Date(timeString);
//     return date.toLocaleTimeString('en-GB', { 
//       hour: '2-digit', 
//       minute: '2-digit' 
//     });
//   };

//   const getSortIcon = (column) => {
//     if (sortBy !== column) return '⇅';
//     return sortOrder === 'asc' ? '↑' : '↓';
//   };

//   return (
//     <div className={styles.wrapper}>
//       {/* <div className={styles.header}>
//         <h2 className={styles.pageTitle}>Invoice Headers</h2>
//         {!loading && (
//           <div className={styles.recordCount}>
//             {totalItems} total records
//           </div>
//         )}
//       </div> */}

//       <div className={styles.filtersSection}>
//         <div className={styles.searchRow}>
//           <div className={styles.searchInputWrapper}>
//             <span className={styles.searchIcon}>🔍</span>
//             <input
//               type="text"
//               placeholder="Search by Invoice#, Customer, SO#, Contact Person..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
//               className={styles.searchInput}
//             />
//             {searchTerm && (
//               <button onClick={handleClearSearch} className={styles.clearSearchButton} title="Clear search">
//                 ✕
//               </button>
//             )}
//           </div>
//           <button onClick={handleSearch} disabled={loading} className={styles.searchButton}>
//             Search
//           </button>
//         </div>

//         <div className={styles.filterRow}>
//           <div className={styles.filterGroup}>
//             <label className={styles.filterLabel}>Month:</label>
//             <select
//               value={selectedMonth}
//               onChange={(e) => handleMonthChange(e.target.value)}
//               className={styles.filterSelect}
//               disabled={loading}
//             >
//               {months.map((month) => (
//                 <option key={month.value} value={month.value}>
//                   {month.label}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className={styles.statusButtonGroup}>
//             {statusFilters.map((filter) => (
//               <button
//                 key={filter.value}
//                 className={`${styles.statusButton} ${selectedStatus === filter.value ? styles.statusButtonActive : ''}`}
//                 onClick={() => handleStatusChange(filter.value)}
//                 disabled={loading}
//               >
//                 {filter.label}
//               </button>
//             ))}
//           </div>

//           <div className={styles.actionButtons}>
//             <button onClick={handleClearFilters} disabled={loading} className={styles.clearButton}>
//               Clear All Filters
//             </button>
//             <button onClick={handleExportExcel} disabled={loading || totalItems === 0} className={styles.excelButton}>
//               <span className={styles.excelIcon}>📊</span>
//               Export Excel
//             </button>
//           </div>
//         </div>
//       </div>

//       {(searchTerm || selectedMonth || selectedStatus) && (
//         <div className={styles.activeFilters}>
//           <span className={styles.activeFiltersLabel}>Active Filters:</span>
//           {searchTerm && (
//             <div className={styles.filterTag}>
//               Search: "{searchTerm}"
//               <button onClick={handleClearSearch} className={styles.removeFilterButton}>✕</button>
//             </div>
//           )}
//           {selectedMonth && (
//             <div className={styles.filterTag}>
//               Month: {months.find(m => m.value === selectedMonth)?.label}
//               <button onClick={() => handleMonthChange('')} className={styles.removeFilterButton}>✕</button>
//             </div>
//           )}
//           {selectedStatus && (
//             <div className={styles.filterTag}>
//               Status: {selectedStatus}
//               <button onClick={() => handleStatusChange('')} className={styles.removeFilterButton}>✕</button>
//             </div>
//           )}
//         </div>
//       )}

//       {error && (
//         <div className={styles.errorMessage}>{error}</div>
//       )}

//       {loading && (
//         <div className={styles.loadingContainer}>
//           <div className={styles.loadingSpinner} />
//           <div className={styles.loadingText}>Loading invoice headers...</div>
//         </div>
//       )}

//       {!loading && (
//         <div className={styles.tableContainer}>
//           <div className={styles.tableWrapper}>
//             <table className={styles.table}>
//               <thead>
//                 <tr>
//                   <th className={styles.th} onClick={() => handleSort('invoiceNum')}>
//                     Invoice# {getSortIcon('invoiceNum')}
//                   </th>
//                   <th className={styles.th} onClick={() => handleSort('invoiceDate')}>
//                     Invoice Date {getSortIcon('invoiceDate')}
//                   </th>
//                   <th className={styles.th} onClick={() => handleSort('status')}>
//                     Status {getSortIcon('status')}
//                   </th>
//                   <th className={styles.th}>SO</th>
//                   <th className={styles.th}>SO Date</th>
//                   <th className={styles.th}>Order Time</th>
//                   <th className={styles.th}>Invoice Time</th>
//                   <th className={styles.th}>Contact Person Name</th>
//                   {/* <th className={styles.th}>Contact Person Code</th> */}
//                   <th className={styles.th}>Due Date</th>
//                   {/* <th className={styles.th}>Customer Code</th> */}
//                   <th className={styles.th}>Customer Name</th>
//                   <th className={styles.th}>Total Lines</th>
//                   <th className={styles.th} onClick={() => handleSort('totalAmount')}>
//                     Total Amount {getSortIcon('totalAmount')}
//                   </th>
//                   <th className={styles.th}>Currency</th>
//                   <th className={styles.th}>Dispatch Date</th>
//                   <th className={styles.th}>Tracking #</th>
//                   <th className={styles.th}>Transport</th>
//                   {/* <th className={styles.th}>Sales Person Code</th> */}
//                   <th className={styles.th}>Sales Person</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {invoices.length > 0 ? (
//                   invoices.map((invoice, index) => {
//                     const hasPdf = pdfAvailability[invoice.invoiceNum] === true;
//                     const isDownloading = downloadingPdf[invoice.invoiceNum] === true;
                    
//                     return (
//                       <tr key={`${invoice.invoiceNum}-${index}`} className={styles.tr}>
//                         {/* <td className={styles.td}>
//                           <button 
//                             onClick={() => handleInvoiceClick(invoice.invoiceNum)} 
//                             className={styles.linkButton}
//                           >
//                             {invoice.invoiceNum}
//                           </button>
//                         </td> */}
//                         <td className={styles.td}>
//                           <div className={styles.invoiceNumberCell}>
//                             <button 
//                               onClick={() => handleInvoiceClick(invoice.invoiceNum)} 
//                               className={styles.linkButton}
//                             >
//                               {invoice.invoiceNum}
//                             </button>
//                             {hasPdf && (
//                               <button
//                                 onClick={(e) => handleDownloadPdf(invoice.invoiceNum, e)}
//                                 disabled={isDownloading}
//                                 className={styles.downloadInvoiceButton}
//                                 title="Download Invoice PDF"
//                               >
//                                 {isDownloading ? 'Downloading...' : 'Invoice PDF'}
//                               </button>
//                             )}
//                           </div>
//                         </td>
//                         <td className={styles.td}>{formatDate(invoice.invoiceDate)}</td>
//                         <td className={styles.td}>
//                           <span className={`${styles.statusBadge} ${styles[`status${invoice.status?.replace(/\s+/g, '')}`]}`}>
//                             {invoice.status}
//                           </span>
//                         </td>
//                         <td className={styles.td}>
//                           {invoice.soNum ? (
//                             <button 
//                               onClick={() => handleInvoiceClick(invoice.invoiceNum)} 
//                               className={styles.linkButton}
//                             >
//                               {invoice.soNum}
//                             </button>
//                           ) : (
//                             'N/A'
//                           )}
//                         </td>
//                         <td className={styles.td}>{formatDate(invoice.soDate)}</td>
//                         <td className={styles.td}>{formatTime(invoice.orderTime)}</td>
//                         <td className={styles.td}>{formatTime(invoice.invoiceTime)}</td>
//                         <td className={styles.td}>{invoice.contactPersonName || 'N/A'}</td>
//                         {/* <td className={styles.td}>{invoice.contactPersonCode || 'N/A'}</td> */}
//                         <td className={styles.td}>{formatDate(invoice.dueDate)}</td>
//                         {/* <td className={styles.td}>{invoice.customerCode}</td> */}
//                         <td className={styles.td}>{invoice.customerName}</td>
//                         <td className={styles.td}>{invoice.totalLines}</td>
//                         <td className={styles.td}>
//                           <span className={styles.totalAmount}>
//                             {formatCurrency(invoice.totalAmount, invoice.currency)}
//                           </span>
//                         </td>
//                         <td className={styles.td}>{invoice.currency}</td>
//                         <td className={styles.td}>{formatDate(invoice.dispatchDate)}</td>
//                         <td className={styles.td}>{invoice.trackingNum || 'N/A'}</td>
//                         <td className={styles.td}>{invoice.transport || 'N/A'}</td>
//                         {/* <td className={styles.td}>{invoice.salesPersonCode || 'N/A'}</td> */}
//                         <td className={styles.td}>{invoice.salesPerson || 'N/A'}</td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td className={styles.td} colSpan="20" style={{ textAlign: 'center', padding: '40px' }}>
//                       {searchTerm || selectedMonth || selectedStatus ? 'No invoices match your filters' : 'No invoices found'}
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}

//       {!loading && invoices.length > 0 && (
//         <div className={styles.paginationSection}>
//           <div className={styles.paginationInfo}>
//             Showing {currentPage * itemsPerPage + 1} - {Math.min((currentPage + 1) * itemsPerPage, totalItems)} of {totalItems} records
//           </div>
//           <div className={styles.paginationControls}>
//             <button
//               onClick={() => setCurrentPage(0)}
//               disabled={currentPage === 0}
//               className={styles.paginationButton}
//             >
//               First
//             </button>
//             <button
//               onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
//               disabled={currentPage === 0}
//               className={styles.paginationButton}
//             >
//               Prev
//             </button>
//             <div className={styles.pageNumber}>{currentPage + 1} / {totalPages}</div>
//             <button
//               onClick={() => setCurrentPage(prev => Math.min(totalPages - 1, prev + 1))}
//               disabled={currentPage === totalPages - 1}
//               className={styles.paginationButton}
//             >
//               Next
//             </button>
//             <button
//               onClick={() => setCurrentPage(totalPages - 1)}
//               disabled={currentPage === totalPages - 1}
//               className={styles.paginationButton}
//             >
//               Last
//             </button>
//           </div>
//         </div>
//       )}

//       {isModalOpen && selectedInvoice && (
//         <InvoiceModal invoice={selectedInvoice} onClose={handleCloseModal} />
//       )}
//     </div>
//   );
// };

// export default HeaderInvoiceTable;

import React, { useState, useEffect, useCallback } from 'react';
import styles from './HeaderInvoiceTable.module.css';
import * as XLSX from 'xlsx';
import { invoiceHeaderApi } from '../../../../../api/invoiceHeader/invoiceHeaderApi';

const HeaderInvoiceTable = ({ onInvoiceClick, savedState }) => {
  const [invoices, setInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(savedState?.currentPage || 0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [searchTerm, setSearchTerm] = useState(savedState?.searchTerm || '');
  const [selectedYear, setSelectedYear] = useState(savedState?.selectedYear || '');
  const [selectedMonth, setSelectedMonth] = useState(savedState?.selectedMonth || '');
  const [selectedStatus, setSelectedStatus] = useState(savedState?.selectedStatus || '');
  const [sortBy, setSortBy] = useState(savedState?.sortBy || '');
  const [sortOrder, setSortOrder] = useState(savedState?.sortOrder || 'desc');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [availableYears, setAvailableYears] = useState([]);
  const [pdfAvailability, setPdfAvailability] = useState({});
  const [downloadingPdf, setDownloadingPdf] = useState({});
  const itemsPerPage = 20;

  const months = [
    { label: 'All Months', value: '' },
    { label: 'January', value: '1' },
    { label: 'February', value: '2' },
    { label: 'March', value: '3' },
    { label: 'April', value: '4' },
    { label: 'May', value: '5' },
    { label: 'June', value: '6' },
    { label: 'July', value: '7' },
    { label: 'August', value: '8' },
    { label: 'September', value: '9' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' }
  ];

  const statusFilters = [
    { label: 'All', value: '' },
    { label: 'Open', value: 'Open' },
    { label: 'Closed', value: 'Closed' },
    { label: 'Partially Open', value: 'Partially Open' },
    { label: 'Canceled', value: 'Canceled' }
  ];

  // Fetch available years
  useEffect(() => {
    const fetchYears = async () => {
      try {
        const data = await invoiceHeaderApi.getInvoiceYears();
        if (data && Array.isArray(data)) {
          setAvailableYears(data);
        }
      } catch (err) {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let y = currentYear; y >= 2023; y--) {
          years.push(y.toString());
        }
        setAvailableYears(years);
      }
    };
    fetchYears();
  }, []);

  const getCurrentTableState = () => ({
    currentPage,
    searchTerm,
    selectedYear,
    selectedMonth,
    selectedStatus,
    sortBy,
    sortOrder
  });

  const fetchInvoices = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const data = await invoiceHeaderApi.getInvoiceHeaders(
        currentPage,
        itemsPerPage,
        searchTerm,
        selectedMonth,
        selectedStatus,
        sortBy,
        sortOrder,
        selectedYear
      );

      if (data && data.invoiceHeaders && Array.isArray(data.invoiceHeaders)) {
        setInvoices(data.invoiceHeaders);
        setTotalPages(data.totalPages || 0);
        setTotalItems(data.totalItems || 0);
      } else {
        setInvoices([]);
        setError('Invalid data received from server');
      }
    } catch (err) {
      setError('Failed to load invoice headers');
      setInvoices([]);
    } finally {
      setLoading(false);
    }
  }, [currentPage, searchTerm, selectedMonth, selectedStatus, sortBy, sortOrder, selectedYear]);

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentPage(0);
    }, 400);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    fetchInvoices();
  }, [fetchInvoices]);

  // Check PDF availability whenever invoices change
  useEffect(() => {
    const checkPdfAvailability = async () => {
      if (invoices.length === 0) {
        setPdfAvailability({});
        return;
      }

      const availabilityMap = {};
      const checkPromises = invoices.map(async (invoice) => {
        try {
          const result = await invoiceHeaderApi.checkPdfExists(invoice.invoiceNum);
          return [invoice.invoiceNum, result?.exists === true];
        } catch {
          return [invoice.invoiceNum, false];
        }
      });

      const results = await Promise.all(checkPromises);
      results.forEach(([invoiceNum, exists]) => {
        availabilityMap[invoiceNum] = exists;
      });
      setPdfAvailability(availabilityMap);
    };

    checkPdfAvailability();
  }, [invoices]);

  const handleDownloadPdf = async (docNum, e) => {
    e.stopPropagation();
    try {
      setDownloadingPdf(prev => ({ ...prev, [docNum]: true }));
      await invoiceHeaderApi.downloadInvoicePdf(docNum);
    } catch {
      alert('Failed to download PDF. Please try again.');
    } finally {
      setDownloadingPdf(prev => ({ ...prev, [docNum]: false }));
    }
  };

  const handleClearFilters = () => {
    setSearchTerm('');
    setSelectedYear('');
    setSelectedMonth('');
    setSelectedStatus('');
    setSortBy('');
    setSortOrder('desc');
    setCurrentPage(0);
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
    setCurrentPage(0);
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    setCurrentPage(0);
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
    setCurrentPage(0);
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(column);
      setSortOrder('asc');
    }
    setCurrentPage(0);
  };

  const handleInvoiceClick = (invoiceNum) => {
    if (onInvoiceClick) {
      onInvoiceClick(invoiceNum, getCurrentTableState());
    }
  };

  const handleExportExcel = async () => {
    try {
      setLoading(true);
      const data = await invoiceHeaderApi.exportInvoiceHeaders(
        searchTerm, selectedMonth, selectedStatus, selectedYear
      );

      if (!data || !Array.isArray(data) || data.length === 0) {
        alert('No data to export');
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(data.map(invoice => ({
        'Invoice#': invoice.invoiceNum,
        'Invoice Date': invoice.invoiceDate,
        'Status': invoice.status,
        'SO': invoice.soNum,
        'SO Date': invoice.soDate,
        'Order Time': invoice.orderTime,
        'Invoice Time': invoice.invoiceTime,
        'Contact Person Name': invoice.contactPersonName,
        'Due Date': invoice.dueDate,
        'Customer Name': invoice.customerName,
        'Total Lines': invoice.totalLines,
        'Total Amount': invoice.totalAmount,
        'Currency': invoice.currency,
        'Dispatch Date': invoice.dispatchDate,
        'Tracking #': invoice.trackingNum,
        'Transport': invoice.transport,
        'Sales Person': invoice.salesPerson
      })));

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoice Headers');
      XLSX.writeFile(workbook, `invoice_headers_${new Date().toISOString().split('T')[0]}.xlsx`);
    } catch {
      alert('Failed to export data');
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount, currency = 'INR') => {
    const symbol = currency === 'USD' ? '$' : '₹';
    return symbol + (amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const formatTime = (timeValue) => {
    if (!timeValue) return 'N/A';
    try {
      const date = new Date(timeValue);
      if (isNaN(date.getTime())) return 'N/A';
      return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
    } catch {
      return 'N/A';
    }
  };

  const getSortIcon = (column) => {
    if (sortBy !== column) return '⇅';
    return sortOrder === 'asc' ? '↑' : '↓';
  };

  const hasActiveFilters = searchTerm || selectedYear || selectedMonth || selectedStatus;

  return (
    <div className={styles.wrapper}>
      <div className={styles.filtersSection}>
        {/* Search Row - no button, auto-fetch on typing */}
        <div className={styles.searchRow}>
          <div className={styles.searchInputWrapper}>
            <span className={styles.searchIcon}>🔍</span>
            <input
              type="text"
              placeholder="Search by Invoice#, Customer, SO#, Contact Person..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
            {searchTerm && (
              <button onClick={() => setSearchTerm('')} className={styles.clearSearchButton} title="Clear search">
                ✕
              </button>
            )}
          </div>
        </div>

        {/* Filter Row */}
        <div className={styles.filterRow}>
          <div className={styles.filterGroupRow}>
            <div className={styles.filterGroup}>
              <label className={styles.filterLabel}>Year:</label>
              <select
                value={selectedYear}
                onChange={(e) => handleYearChange(e.target.value)}
                className={styles.filterSelect}
                disabled={loading}
              >
                <option value="">All Years</option>
                {availableYears.map((year) => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
            </div>

            <div className={styles.filterGroup}>
              <label className={styles.filterLabel}>Month:</label>
              <select
                value={selectedMonth}
                onChange={(e) => handleMonthChange(e.target.value)}
                className={styles.filterSelect}
                disabled={loading}
              >
                {months.map((month) => (
                  <option key={month.value} value={month.value}>{month.label}</option>
                ))}
              </select>
            </div>

            <div className={styles.statusButtonGroup}>
              {statusFilters.map((filter) => (
                <button
                  key={filter.value}
                  className={`${styles.statusButton} ${selectedStatus === filter.value ? styles.statusButtonActive : ''}`}
                  onClick={() => handleStatusChange(filter.value)}
                  disabled={loading}
                >
                  {filter.label}
                </button>
              ))}
            </div>
          </div>

          <div className={styles.actionButtons}>
            <button onClick={handleClearFilters} disabled={loading} className={styles.clearButton}>
              Clear All Filters
            </button>
            <button onClick={handleExportExcel} disabled={loading || totalItems === 0} className={styles.excelButton}>
              <span className={styles.excelIcon}>📊</span>
              Export Excel
            </button>
          </div>
        </div>
      </div>

      {hasActiveFilters && (
        <div className={styles.activeFilters}>
          <span className={styles.activeFiltersLabel}>Active Filters:</span>
          {searchTerm && (
            <div className={styles.filterTag}>
              Search: "{searchTerm}"
              <button onClick={() => setSearchTerm('')} className={styles.removeFilterButton}>✕</button>
            </div>
          )}
          {selectedYear && (
            <div className={styles.filterTag}>
              Year: {selectedYear}
              <button onClick={() => handleYearChange('')} className={styles.removeFilterButton}>✕</button>
            </div>
          )}
          {selectedMonth && (
            <div className={styles.filterTag}>
              Month: {months.find(m => m.value === selectedMonth)?.label}
              <button onClick={() => handleMonthChange('')} className={styles.removeFilterButton}>✕</button>
            </div>
          )}
          {selectedStatus && (
            <div className={styles.filterTag}>
              Status: {selectedStatus}
              <button onClick={() => handleStatusChange('')} className={styles.removeFilterButton}>✕</button>
            </div>
          )}
        </div>
      )}

      {error && <div className={styles.errorMessage}>{error}</div>}

      {loading && (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingSpinner} />
          <div className={styles.loadingText}>Loading invoice headers...</div>
        </div>
      )}

      {!loading && (
        <div className={styles.tableContainer}>
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.th} onClick={() => handleSort('invoiceNum')}>
                    Invoice# {getSortIcon('invoiceNum')}
                  </th>
                  <th className={styles.th} onClick={() => handleSort('invoiceDate')}>
                    Invoice Date {getSortIcon('invoiceDate')}
                  </th>
                  <th className={styles.th} onClick={() => handleSort('status')}>
                    Status {getSortIcon('status')}
                  </th>
                  <th className={styles.th}>SO</th>
                  <th className={styles.th}>SO Date</th>
                  <th className={styles.th}>Order Time</th>
                  <th className={styles.th}>Invoice Time</th>
                  <th className={styles.th}>Contact Person Name</th>
                  <th className={styles.th}>Due Date</th>
                  <th className={styles.th}>Customer Name</th>
                  <th className={styles.th}>Total Lines</th>
                  <th className={styles.th} onClick={() => handleSort('totalAmount')}>
                    Total Amount {getSortIcon('totalAmount')}
                  </th>
                  <th className={styles.th}>Currency</th>
                  <th className={styles.th}>Dispatch Date</th>
                  <th className={styles.th}>Tracking #</th>
                  <th className={styles.th}>Transport</th>
                  <th className={styles.th}>Sales Person</th>
                </tr>
              </thead>
              <tbody>
                {invoices.length > 0 ? (
                  invoices.map((invoice, index) => {
                    const hasPdf = pdfAvailability[invoice.invoiceNum] === true;
                    const isDownloading = downloadingPdf[invoice.invoiceNum] === true;

                    return (
                      <tr key={`${invoice.invoiceNum}-${index}`} className={styles.tr}>
                        <td className={styles.td}>
                          <div className={styles.invoiceNumberCell}>
                            <span
                              onClick={() => handleInvoiceClick(invoice.invoiceNum)}
                              className={styles.clickableCell}
                            >
                              {invoice.invoiceNum}
                            </span>
                            {hasPdf && (
                              <button
                                onClick={(e) => handleDownloadPdf(invoice.invoiceNum, e)}
                                disabled={isDownloading}
                                className={styles.downloadInvoiceButton}
                                title="Download Invoice PDF"
                              >
                                {isDownloading ? 'Downloading...' : 'Invoice PDF'}
                              </button>
                            )}
                          </div>
                        </td>
                        <td className={styles.td}>{formatDate(invoice.invoiceDate)}</td>
                        <td className={styles.td}>
                          <span className={`${styles.statusBadge} ${styles[`status${invoice.status?.replace(/\s+/g, '')}`]}`}>
                            {invoice.status}
                          </span>
                        </td>
                        <td className={styles.td}>
                          {invoice.soNum ? (
                            <span
                              onClick={() => handleInvoiceClick(invoice.invoiceNum)}
                              className={styles.clickableCell}
                            >
                              {invoice.soNum}
                            </span>
                          ) : 'N/A'}
                        </td>
                        <td className={styles.td}>{formatDate(invoice.soDate)}</td>
                        <td className={styles.td}>{formatTime(invoice.orderTime)}</td>
                        <td className={styles.td}>{formatTime(invoice.invoiceTime)}</td>
                        <td className={styles.td}>{invoice.contactPersonName || 'N/A'}</td>
                        <td className={styles.td}>{formatDate(invoice.dueDate)}</td>
                        <td className={styles.td}>{invoice.customerName}</td>
                        <td className={styles.td}>{invoice.totalLines}</td>
                        <td className={styles.td}>
                          <span className={styles.totalAmount}>
                            {formatCurrency(invoice.totalAmount, invoice.currency)}
                          </span>
                        </td>
                        <td className={styles.td}>{invoice.currency}</td>
                        <td className={styles.td}>{formatDate(invoice.dispatchDate)}</td>
                        <td className={styles.td}>{invoice.trackingNum || 'N/A'}</td>
                        <td className={styles.td}>{invoice.transport || 'N/A'}</td>
                        <td className={styles.td}>{invoice.salesPerson || 'N/A'}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td className={styles.td} colSpan="17" style={{ textAlign: 'center', padding: '40px' }}>
                      {hasActiveFilters ? 'No invoices match your filters' : 'No invoices found'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {!loading && invoices.length > 0 && (
        <div className={styles.paginationSection}>
          <div className={styles.paginationInfo}>
            Showing {currentPage * itemsPerPage + 1} - {Math.min((currentPage + 1) * itemsPerPage, totalItems)} of {totalItems} records
          </div>
          <div className={styles.paginationControls}>
            <button onClick={() => setCurrentPage(0)} disabled={currentPage === 0} className={styles.paginationButton}>First</button>
            <button onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))} disabled={currentPage === 0} className={styles.paginationButton}>Prev</button>
            <div className={styles.pageNumber}>{currentPage + 1} / {totalPages}</div>
            <button onClick={() => setCurrentPage(prev => Math.min(totalPages - 1, prev + 1))} disabled={currentPage === totalPages - 1} className={styles.paginationButton}>Next</button>
            <button onClick={() => setCurrentPage(totalPages - 1)} disabled={currentPage === totalPages - 1} className={styles.paginationButton}>Last</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderInvoiceTable;